import React, { useState, useMemo, useEffect } from "react";
import { PDFViewer } from '@react-pdf/renderer';
import PdfInvoice from './InvoiceWithPdfPreview';
import { pdf } from "@react-pdf/renderer";
import Select from 'react-select';
import moment from "moment";
import axios from "axios";
import {
  Space,
  Tooltip,
  Button,
  Dropdown,
  Menu,
  Modal,
  Form,
  Input,
  InputNumber,
  message,
  Row,
  Col,
  DatePicker,
  Divider,
  Table,
  Card,
} from "antd";
import {
  DownloadOutlined,
  MailOutlined,
  EyeOutlined,
  EditOutlined,
  CaretDownOutlined,
  CheckOutlined,
  CloseOutlined,
  PlusOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import jsPDF from "jspdf";
import "jspdf-autotable";
import styles from "./partnerInvoice.module.css";

// Fetch partner bank details by partner name
const fetchPartnerBankDetails = async (partnerName, token) => {
  if (!partnerName) return null;
  try {
    const url = `${process.env.REACT_APP_BE_URL}/getpartnervendoronDetails?partnerName=${encodeURIComponent(partnerName)}`;
    const response = await axios.get(url, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (
      response.status === 200 &&
      response.data &&
      Array.isArray(response.data.partnerVendorDetails) &&
      response.data.partnerVendorDetails.length > 0
    ) {
      return response.data.partnerVendorDetails[0];
    }
    return null;
  } catch (error) {
    console.error('Failed to fetch partner bank details:', error);
    return null;
  }
};
// Comprehensive list of country currencies
const currencyOptions = [
  { value: "USD", label: "USD - US Dollar" },
  { value: "EUR", label: "EUR - Euro" },
  { value: "GBP", label: "GBP - British Pound" },
  { value: "INR", label: "INR - Indian Rupee" },
  { value: "AUD", label: "AUD - Australian Dollar" },
  { value: "CAD", label: "CAD - Canadian Dollar" },
  { value: "CHF", label: "CHF - Swiss Franc" },
  { value: "CNY", label: "CNY - Chinese Yuan" },
  { value: "JPY", label: "JPY - Japanese Yen" },
  { value: "NZD", label: "NZD - New Zealand Dollar" },
  { value: "SGD", label: "SGD - Singapore Dollar" },
  { value: "HKD", label: "HKD - Hong Kong Dollar" },
  { value: "KRW", label: "KRW - South Korean Won" },
  { value: "SEK", label: "SEK - Swedish Krona" },
  { value: "NOK", label: "NOK - Norwegian Krone" },
  { value: "DKK", label: "DKK - Danish Krone" },
  { value: "ZAR", label: "ZAR - South African Rand" },
  { value: "BRL", label: "BRL - Brazilian Real" },
  { value: "RUB", label: "RUB - Russian Ruble" },
  { value: "TRY", label: "TRY - Turkish Lira" },
  { value: "MXN", label: "MXN - Mexican Peso" },
  { value: "AED", label: "AED - UAE Dirham" },
  { value: "SAR", label: "SAR - Saudi Riyal" },
  { value: "THB", label: "THB - Thai Baht" },
  { value: "IDR", label: "IDR - Indonesian Rupiah" },
  { value: "MYR", label: "MYR - Malaysian Ringgit" },
  { value: "PHP", label: "PHP - Philippine Peso" },
  { value: "VND", label: "VND - Vietnamese Dong" },
  { value: "ARS", label: "ARS - Argentine Peso" },
  { value: "CLP", label: "CLP - Chilean Peso" },
  { value: "COP", label: "COP - Colombian Peso" },
  { value: "EGP", label: "EGP - Egyptian Pound" },
  { value: "ILS", label: "ILS - Israeli New Shekel" },
  { value: "KWD", label: "KWD - Kuwaiti Dinar" },
  { value: "QAR", label: "QAR - Qatari Riyal" },
  { value: "PKR", label: "PKR - Pakistani Rupee" },
  { value: "BDT", label: "BDT - Bangladeshi Taka" },
  { value: "NGN", label: "NGN - Nigerian Naira" },
  { value: "UAH", label: "UAH - Ukrainian Hryvnia" },
  { value: "CZK", label: "CZK - Czech Koruna" },
  { value: "PLN", label: "PLN - Polish Zloty" },
  { value: "HUF", label: "HUF - Hungarian Forint" },
  { value: "RON", label: "RON - Romanian Leu" },
  { value: "TWD", label: "TWD - New Taiwan Dollar" },
  // Add more currencies as needed
];

const { TextArea } = Input;

function PartnerInvoice() {
  const [invoices, setInvoices] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [isEmailModalVisible, setIsEmailModalVisible] = useState(false);
  const [isViewModalVisible, setIsViewModalVisible] = useState(false);
  const [isGenerateModalVisible, setIsGenerateModalVisible] = useState(false);
  const [generatingInvoice, setGeneratingInvoice] = useState(false);
  const [updatingPayment, setUpdatingPayment] = useState(false);
  const [updatingInvoiceId, setUpdatingInvoiceId] = useState(null);
  const [emailForm] = Form.useForm();
  const [generateForm] = Form.useForm();
  const [sendingEmail, setSendingEmail] = useState(false);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewData, setPreviewData] = useState(null);
  const [formData, setFormData] = useState({
    partner: "",
    invoiceFrom: "",
    currencySymbol: "",
    invoiceDate: null,
    dueDate: null,
    refPoNumber: "",
    termsConditions: "",
  });
  const [items, setItems] = useState([{ description: "", quantity: 0, rate: 0, tax: 0, LineItemTotal: 0 }]);
  const [additionalTaxConfig, setAdditionalTaxConfig] = useState({ enabled: false, percentage: 0, taxName: "" });
  const [showAdditionalTaxForm, setShowAdditionalTaxForm] = useState(false);
  const [partnerBankDetails, setPartnerBankDetails] = useState(null);
  const [organisationPartnerDetails, setOrganisationPartnerDetails] = useState(null);
  const token = localStorage.getItem("token");
  const [employees, setEmployees] = useState([]); // Initialize as empty array

  // Fetch organisation/vendor details for Invoice To
  useEffect(() => {
    const fetchOrganisationVendorDetails = async () => {
      try {
        const url = `${process.env.REACT_APP_BE_URL}/getConfigurationCenter`;
        const response = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.status === 200 && response.data && response.data.partnerDetails) {
          setOrganisationPartnerDetails(response.data.partnerDetails);
          console.log("partnerDetails:", response.data.partnerDetails);
        } else {
          setOrganisationPartnerDetails(null);
        }
      } catch (error) {
        console.error('Failed to fetch organisation/vendor details:', error);
        setOrganisationPartnerDetails(null);
      }
    };
    fetchOrganisationVendorDetails();
  }, [token]);

  let partnerArray = [];
  if (Array.isArray(organisationPartnerDetails)) {
    partnerArray = organisationPartnerDetails;
  } else if (organisationPartnerDetails && typeof organisationPartnerDetails === 'object') {
    partnerArray = [organisationPartnerDetails];
  }
  const partnerOptions = partnerArray.map((emp) => ({
    value: emp.partnerOrganizationName,
    label: `${emp.partnerOrganizationName}`,
  }));

  // Fetch employees
  useEffect(() => {
    const fetchOrganisationVendorDetails = async () => {
      try {
        const url = `${process.env.REACT_APP_BE_URL}/getpartnervendoronDetails`;
        const response = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });
        
        if (response.status === 200 && response.data) {
          const activeEmployees = response.data.partnerVendorDetails || [];
          setEmployees(activeEmployees);
        } else {
          setEmployees([]); // Set empty array instead of null
        }
      } catch (error) {
        console.error('Failed to fetch organisation/vendor details:', error);
        setEmployees([]); // Set empty array instead of null
      }
    };
    fetchOrganisationVendorDetails();
  }, [token]);

  const assignToOptions = useMemo(() => {
    if (!employees || !Array.isArray(employees)) {
      return [];
    }
    
    return employees
      .filter(emp => emp?.UserType?.toLowerCase() === 'partner')
      .map((emp) => ({
        value: emp.PartnerName,
        label: `${emp.PartnerName}`,
      }));
  }, [employees]);

  // Fetch partner bank details when partner changes in form
  useEffect(() => {
    const getBankDetails = async () => {
      const cleanPartnerName = (formData.partner || '').trim();
      if (cleanPartnerName) {
        const details = await fetchPartnerBankDetails(cleanPartnerName, token);
        setPartnerBankDetails(details);
      } else {
        setPartnerBankDetails(null);
      }
    };
    getBankDetails();
  }, [formData.partner, token]);

  // Fetch invoices
  const fetchInvoices = async () => {
    setLoading(true);
    try {
      const URL = process.env.REACT_APP_BE_URL + "/getPartnerInvoices";
      const response = await axios.get(URL, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        setInvoices(
          response.data.invoiceDetails.map((inv) => ({
            ...inv,
            invoiceId: inv.invoiceNo,
            partner: inv.partner,
            invoiceFrom: inv.invoiceFrom,
            currencySymbol: inv.currencySymbol,
            invoiceDate: inv.invoiceDate,
            dueDate: inv.dueDate,
            referencePONo: inv.referencePONo,
            lineItems: inv.lineItems,
            taxName: inv.taxName,
            taxPercentage: inv.taxPercentage,
            taxAmount: inv.taxAmount,
            subtotal: inv.subtotal,
            total: inv.total,
            notes: inv.notes,
            invoiceFile: inv.invoicefile,
            status: inv.status || "pending",
            month: moment(inv.invoiceDate).format("MMMM"),
            year: moment(inv.invoiceDate).year(),
          }))
        );
      }
    } catch (error) {
      console.error("Failed to fetch invoices:", error);
      message.error("No Invoices Found");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchInvoices();
  }, [token]);

  // Generate Invoice Handlers
  const handleGenerateInvoiceClick = () => {
    setIsGenerateModalVisible(true);
    generateForm.resetFields();
    setItems([{ description: "", quantity: 0, rate: 0, tax: 0, LineItemTotal: 0 }]);
    setFormData({
      partner: "",
      invoiceFrom: "",
      currencySymbol: "",
      invoiceDate: null,
      dueDate: null,
      refPoNumber: "",
      termsConditions: "",
    });
    setAdditionalTaxConfig({ enabled: false, percentage: 0, taxName: "" });
    setShowAdditionalTaxForm(false);
    setPreviewData(null);
  };

  const handleGenerateModalCancel = () => {
    setIsGenerateModalVisible(false);
    generateForm.resetFields();
    setItems([{ description: "", quantity: 0, rate: 0, tax: 0, LineItemTotal: 0 }]);
    setAdditionalTaxConfig({ enabled: false, percentage: 0, taxName: "" });
    setShowAdditionalTaxForm(false);
    setPreviewData(null);
  };

  const updateFormData = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  const addItem = () => {
    setItems((prev) => [
      ...prev,
      { description: "", quantity: 0, rate: 0, tax: 0, LineItemTotal: 0 },
    ]);
  };

  const deleteItem = (index) => {
    setItems((prev) => prev.filter((_, i) => i !== index));
  };

  const updateItem = (index, field, value) => {
    setItems((prev) => {
      const newItems = [...prev];
      newItems[index] = { ...newItems[index], [field]: value };
      newItems[index].LineItemTotal = calculateItemSubtotal(
        newItems[index].quantity || 0,
        newItems[index].rate || 0,
        newItems[index].tax || additionalTaxConfig.percentage || 0
      );
      return newItems;
    });
  };

  const calculateItemSubtotal = (quantity, rate, taxPercentage) => {
    const baseTotal = quantity * rate;
    return baseTotal;
  };

  const calculateGrandTotal = () => {
    const subtotal = items.reduce(
      (total, item) => total + (item.quantity || 0) * (item.rate || 0),
      0
    );
    const tax = (subtotal * (additionalTaxConfig.percentage || 0)) / 100;
    return subtotal + tax;
  };

  const calculateItemTax = (quantity, rate, taxPercentage) => {
    return (quantity * rate * (taxPercentage || 0)) / 100;
  };

  const getTaxDisplayText = () => {
    const taxNames = [...new Set(items.map((item) => item.taxName).filter(Boolean))];
    if (additionalTaxConfig.enabled && additionalTaxConfig.taxName) {
      taxNames.push(additionalTaxConfig.taxName);
    }
    return taxNames.length > 0 ? taxNames.join(", ") : "Tax";
  };

  const handlePreview = () => {
    const formValues = generateForm.getFieldsValue();

    if (!formValues.invoiceNo) {
      message.error("Invoice Number is required");
      return;
    }
    if (!formData.partner) {
      message.error("Partner is required");
      return;
    }
    if (!formData.invoiceFrom) {
      message.error("Invoice From is required");
      return;
    }
    if (!formData.currencySymbol) {
      message.error("Currency is required");
      return;
    }
    if (!formData.invoiceDate) {
      message.error("Invoice Date is required");
      return;
    }
    // if (!formData.dueDate) {
    //   message.error("Due Date is required");
    //   return;
    // }
    if (!formData.termsConditions) {
      message.error("Notes/Payment Terms is required");
      return;
    }

    // all fields filled — do preview



    // If validation passes, create preview data
    const invoiceData = {
      invoiceNumber: formValues.invoiceNo,
      partner: formData.partner,
      invoiceFrom: formData.invoiceFrom,
      currency: formData.currencySymbol,
      invoiceDate: formData.invoiceDate
        ? moment(formData.invoiceDate).format("YYYY-MM-DD")
        : "",
      dueDate: formData.dueDate
        ? moment(formData.dueDate).format("YYYY-MM-DD")
        : "",
      refPoNumber: formData.refPoNumber || "N/A",
      lineItems: items.map(item => ({
        ...item,
        LineItemTotal: (item.quantity || 0) * (item.rate || 0)
      })),
      taxName: getTaxDisplayText(),
      taxPercentage: additionalTaxConfig.enabled ? additionalTaxConfig.percentage : 0,
      taxAmount: items.reduce(
        (total, item) => total + ((item.quantity || 0) * (item.rate || 0) * (additionalTaxConfig.percentage || 0)) / 100,
        0
      ),
      subtotal: items.reduce(
        (total, item) => total + (item.quantity || 0) * (item.rate || 0),
        0
      ),
      total: calculateGrandTotal(),
      notes: formData.termsConditions
    };
    setPreviewData(invoiceData);
    setPreviewVisible(true);
  };

  const generateInvoicePDF = (invoiceData, partnerBankDetailsArg) => {
    // Create a new jsPDF instance
    const doc = new jsPDF();

    // Add header
    doc.setFontSize(20);
    doc.setTextColor(40, 40, 40);
    doc.text("INVOICE", 105, 20, { align: "center" });

    doc.setFontSize(12);
    doc.setTextColor(100, 100, 100);
    doc.text(`Invoice Number: ${invoiceData.invoiceNumber}`, 14, 30);
    doc.text(`Date: ${invoiceData.invoiceDate}`, 14, 37);
    doc.text(`Due Date: ${invoiceData.dueDate}`, 14, 44);

    // Add from and to details
    doc.setFontSize(14);
    doc.setTextColor(40, 40, 40);
    doc.text("From:", 14, 60);
    doc.setFontSize(12);
    doc.text(invoiceData.invoiceFrom, 14, 67);

    doc.setFontSize(14);
    doc.text("To:", 14, 80);
    doc.setFontSize(12);
    doc.text(invoiceData.partner, 14, 87);

    // Add line items table
    const tableColumn = ["Description", "Quantity", "Rate", "Tax %", "Total"];
    const tableRows = [];

    invoiceData.lineItems.forEach(item => {
      const itemData = [
        item.description,
        item.quantity,
        `${invoiceData.currency} ${item.rate.toFixed(2)}`,
        `${item.tax || 0}%`,
        `${invoiceData.currency} ${item.LineItemTotal.toFixed(2)}`
      ];
      tableRows.push(itemData);
    });

    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 100,
      theme: 'grid',
      styles: { fontSize: 10 },
      headStyles: { fillColor: [79, 129, 188] }
    });

    // Add totals
    const finalY = doc.lastAutoTable.finalY + 10;

    doc.setFontSize(12);
    doc.text("Subtotal:", 140, finalY);
    doc.text(`${invoiceData.currency} ${invoiceData.subtotal.toFixed(2)}`, 180, finalY, { align: "right" });

    doc.text(`Tax (${invoiceData.taxName}):`, 140, finalY + 7);
    doc.text(`${invoiceData.currency} ${invoiceData.taxAmount.toFixed(2)}`, 180, finalY + 7, { align: "right" });

    doc.setFontSize(14);
    doc.setFont(undefined, 'bold');
    doc.text("Total:", 140, finalY + 17);
    doc.text(`${invoiceData.currency} ${invoiceData.total.toFixed(2)}`, 180, finalY + 17, { align: "right" });

    // Add notes
    if (invoiceData.notes && invoiceData.notes !== "N/A") {
      doc.setFontSize(12);
      doc.setFont(undefined, 'normal');
      doc.text("Notes/Payment Terms:", 14, finalY + 30);
      doc.text(invoiceData.notes, 14, finalY + 37, { maxWidth: 180 });
    }

    // Save the PDF
    return doc.output('blob');
  };



  const handleSubmit = async () => {
    try {
      setLoading(true);

      // // Validate required fields
      if (
        !previewData.invoiceNumber ||
        !previewData.partner ||
        !previewData.invoiceFrom ||
        !previewData.currency ||
        !previewData.invoiceDate ||
        !previewData.dueDate
      ) {
        message.error("Please fill all required fields");
        return;
      }

      // Calculate proper values
      const subtotal = items.reduce(
        (total, item) => total + (item.quantity || 0) * (item.rate || 0),
        0
      );

      const taxPercentage = additionalTaxConfig.enabled ? additionalTaxConfig.percentage : 0;
      const taxAmount = (subtotal * taxPercentage) / 100;
      const total = subtotal + taxAmount;

      // Prepare data exactly as API expects
      const invoiceData = {
        InvoiceNo: previewData.invoiceNumber,
        partner: previewData.partner,
        invoiceFrom: previewData.invoiceFrom,
        currency: previewData.currency, // Changed from currencySymbol to currency
        invoiceDate: previewData.invoiceDate,
        dueDate: previewData.dueDate,
        referencePONo: previewData.refPoNumber,
        lineItems: items.map(item => ({
          description: item.description,
          quantity: item.quantity,
          rate: item.rate,
          LineItemTotal: (item.quantity || 0) * (item.rate || 0) // Calculate without tax
        })),
        taxName: getTaxDisplayText(),
        taxPercentage: taxPercentage, // Added taxPercentage field
        taxAmount: taxAmount, // Recalculated tax amount
        subtotal: subtotal, // Recalculated subtotal
        total: total, // Recalculated total
        Notes: previewData.notes
      };

      // Generate PDF blob
      const blob = await pdf(<PdfInvoice data={previewData} partnerBankDetails={partnerBankDetails} organisationPartnerDetails={organisationPartnerDetails} />).toBlob();

      // Prepare FormData
      const formDataToSend = new FormData();
      formDataToSend.append("partnerDetails", JSON.stringify(invoiceData));
      formDataToSend.append(
        "invoiceUpload",
        blob,
        `invoice_${previewData.invoiceNumber}.pdf`
      );

      // API call
      const URL = process.env.REACT_APP_BE_URL + "/partnerInvoiceUpload";
      const response = await axios.post(
        URL,
        formDataToSend,
        {
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "multipart/form-data"
          }
        }
      );
      if (response.data.status === "Success") {
        message.success(response.data.message);

        await fetchInvoices();

        // Close modal and reset form
        setPreviewVisible(false);
        setIsGenerateModalVisible(false);
        generateForm.resetFields();
        setItems([{ description: "", quantity: 0, rate: 0, tax: 0, LineItemTotal: 0 }]);
        setPreviewData(null);

      } else {
        message.error(`Failed to create invoice: ${response.data.message}`);
      }

    } catch (error) {
      console.error("Invoice creation error:", error);
      message.error(`Failed to create invoice: ${error.response?.data?.message || error.message}`);
    } finally {
      setLoading(false);
    }
  };

  // Updated handleDownloadPDF function to open PDF in new tab
  const handleDownloadPDF = async () => {
    if (previewData) {
      try {
        const blob = await pdf(<PdfInvoice data={previewData} partnerBankDetails={partnerBankDetails} organisationPartnerDetails={organisationPartnerDetails} />).toBlob();
        const pdfUrl = URL.createObjectURL(blob);
        window.open(pdfUrl, '_blank');
        setTimeout(() => URL.revokeObjectURL(pdfUrl), 100);
        message.success(`Invoice ${previewData.invoiceNumber} opened in new tab`);
      } catch (error) {
        console.error("Error generating PDF:", error);
        message.error("Failed to generate PDF for preview");
      }
    } else {
      message.error("No invoice data available to preview");
    }
  };

  // Updated handleDownloadInvoiceFile to open existing invoice in new tab
  const handleDownloadInvoiceFile = (invoice) => {
    if (invoice && invoice.invoiceFile) {
      window.open(invoice.invoiceFile, '_blank');
      message.success(`Invoice ${invoice.invoiceId} opened in new tab`);
    } else {
      message.error(`No invoice file available for ${invoice?.invoiceId || "this invoice"}`);
    }
  };

  const handleOpenInvoiceInNewTab = (invoice) => {
    if (invoice && invoice.invoiceFile) {
      window.open(invoice.invoiceFile, '_blank');
      message.success(`Invoice ${invoice.invoiceId} opened in new tab`);
    } else {
      message.error(`No invoice file available for ${invoice?.invoiceId || "this invoice"}`);
    }
  };

  const handleSendEmail = async (values) => {
    setSendingEmail(true);
    try {
      if (previewData) {
        const blob = await pdf(<PdfInvoice data={previewData} partnerBankDetails={partnerBankDetails} organisationPartnerDetails={organisationPartnerDetails} />).toBlob();
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `invoice_${previewData.invoiceNumber}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        const subject = `Invoice ${previewData.invoiceNumber} from ${previewData.invoiceFrom}`;
        const body = `Please find the details for Invoice No: ${previewData.invoiceNumber}
Partner: ${previewData.partner}
Invoice From: ${previewData.invoiceFrom}
Currency: ${previewData.currency}
Invoice Date: ${previewData.invoiceDate}
Due Date: ${previewData.dueDate}
Reference PO No: ${previewData.refPoNumber}
Total: ${previewData.total}

Note: The invoice PDF will be attached to this email.`;
        const mailtoLink = `mailto:${values.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

        window.location.href = mailtoLink;

        setIsEmailModalVisible(false);
        emailForm.resetFields();
        message.success('Email client opened successfully');
      } else {
        message.error("No invoice data available to send.");
      }
    } catch (error) {
      console.error("Email sending error:", error);
      message.error(`Failed to prepare email: ${error.message || "Unknown error"}`);
    } finally {
      setSendingEmail(false);
    }
  };

  const handleEmailClick = (invoice) => {
    setSelectedInvoice(invoice);
    setIsEmailModalVisible(true);
    emailForm.resetFields();
  };

  const handleEmailModalCancel = () => {
    setIsEmailModalVisible(false);
    emailForm.resetFields();
  };

  const handleEmailSend = async (values) => {
    try {
      if (selectedInvoice) {
        const subject = `Invoice ${selectedInvoice.invoiceId} from ${selectedInvoice.invoiceFrom}`;
        const body = `Please find the details for Invoice No: ${selectedInvoice.invoiceId}
Partner: ${selectedInvoice.partner}
Invoice From: ${selectedInvoice.invoiceFrom}
Currency: ${selectedInvoice.currencySymbol}
Invoice Date: ${moment(selectedInvoice.invoiceDate).format("YYYY-MM-DD")}
Due Date: ${moment(selectedInvoice.dueDate).format("YYYY-MM-DD")}
Reference PO No: ${selectedInvoice.referencePONo}
Total: ${selectedInvoice.total}
Status: ${selectedInvoice.status}

Note: The invoice PDF will be attached to this email.`;

        const mailtoLink = `mailto:${values.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

        window.location.href = mailtoLink;

        setIsEmailModalVisible(false);
        emailForm.resetFields();
        message.success('Email client opened successfully');
      }
    } catch (error) {
      console.error('Email error:', error);
      message.error('Failed to open email client');
    }
  };

  const handleViewClick = (invoice) => {
    setSelectedInvoice(invoice);
    setIsViewModalVisible(true);
  };

  const handleViewModalCancel = () => {
    setIsViewModalVisible(false);
    setSelectedInvoice(null);
  };

  const getItemColumns = () => [
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (text, record, index) => (
        <Input
          value={text}
          onChange={(e) => updateItem(index, "description", e.target.value)}
          placeholder="Enter description"
        />
      ),
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
      render: (text, record, index) => (
        <InputNumber
          min={0}
          value={text}
          onChange={(value) => updateItem(index, "quantity", value || 0)}
          placeholder="0"
          style={{ width: '100%' }}
        />
      ),
    },
    {
      title: "Rate",
      dataIndex: "rate",
      key: "rate",
      render: (text, record, index) => (
        <InputNumber
          min={0}
          value={text}
          onChange={(value) => updateItem(index, "rate", value || 0)}
          placeholder="0.00"
          style={{ width: '100%' }}
        />
      ),
    },
    {
      title: "Total",
      dataIndex: "LineItemTotal",
      key: "LineItemTotal",
      render: (text) => text.toFixed(2),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record, index) => (
        <Button
          icon={<DeleteOutlined />}
          onClick={() => deleteItem(index)}
          danger
          size="small"
          style={{ borderRadius: "4px" }}
        />
      ),
    },
  ];

  const renderActions = (invoice) => {
    const isPaid = invoice.status === "Paid";
    const isRejected = invoice.status === "reject";
    const isUpdating = updatingPayment && updatingInvoiceId === invoice.id;

    return (
      <Space size={6}>
        <Tooltip title="Open Invoice in New Tab">
          <Button
            type="primary"
            icon={<DownloadOutlined />}
            size="small"
            loading={generatingInvoice && selectedInvoice?.invoiceId === invoice.invoiceId}
            style={{
              backgroundColor: "#004f7c",
              borderColor: "#004f7c",
              fontSize: "12px",
              padding: "4px 8px",
              height: "28px",
              minWidth: "28px",
            }}
            onClick={() => handleDownloadInvoiceFile(invoice)}
          />
        </Tooltip>
        <Tooltip title="Send Email">
          <Button
            type="default"
            icon={<MailOutlined />}
            size="small"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleEmailClick(invoice);
              return false;
            }}
            style={{
              borderColor: "#004f7c",
              color: "#004f7c",
              fontSize: "12px",
              padding: "4px 8px",
              height: "28px",
              minWidth: "28px",
            }}
          />
        </Tooltip>
        <Tooltip
          title={
            isPaid
              ? "View Paid Invoice"
              : isRejected
                ? "View Rejected Invoice"
                : "View Invoice"
          }
        >
          <Button
            type="default"
            icon={<EyeOutlined />}
            size="small"
            onClick={() => handleViewClick(invoice)}
            style={{
              borderColor: isPaid ? "#52c41a" : isRejected ? "#ff4d4f" : "#004f7c",
              color: isPaid ? "#52c41a" : isRejected ? "#ff4d4f" : "#004f7c",
              backgroundColor: isPaid
                ? "#f6ffed"
                : isRejected
                  ? "#fff2f0"
                  : "transparent",
              fontSize: "12px",
              padding: "4px 8px",
              height: "28px",
              minWidth: "28px",
            }}
          />
        </Tooltip>
        {!isPaid && invoice.status !== "reject" && (
          <Tooltip title="Update Payment Status">
            <Dropdown
              overlay={getStatusDropdownMenu(invoice)}
              trigger={["click"]}
              placement="bottomRight"
              disabled={isUpdating}
            >
              <Button
                type="default"
                loading={isUpdating}
                size="small"
                style={{
                  borderColor: "#004f7c",
                  color: "#004f7c",
                  fontSize: "11px",
                  padding: "4px 6px",
                  height: "28px",
                  minWidth: "28px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {!isUpdating && (
                  <>
                    <EditOutlined style={{ fontSize: "11px", marginRight: "2px" }} />
                    <CaretDownOutlined style={{ fontSize: "10px" }} />
                  </>
                )}
              </Button>
            </Dropdown>
          </Tooltip>
        )}
      </Space>
    );
  };

  const getStatusDropdownMenu = (invoice) => (
    <Menu
      onClick={({ key }) => handleStatusUpdate(invoice, key)}
      style={{
        borderRadius: "8px",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
        border: "1px solid #f0f0f0",
      }}
    >
      <Menu.Item
        key="Paid"
        style={{
          padding: "12px 16px",
          display: "flex",
          alignItems: "center",
          fontSize: "14px",
          fontWeight: "500",
        }}
      >
        <CheckOutlined style={{ color: "#52c41a", marginRight: "8px" }} />
        Paid
      </Menu.Item>
      <Menu.Item
        key="reject"
        style={{
          padding: "12px 16px",
          display: "flex",
          alignItems: "center",
          fontSize: "14px",
          fontWeight: "500",
        }}
      >
        <CloseOutlined style={{ color: "#ff4d4f", marginRight: "8px" }} />
        Reject
      </Menu.Item>
    </Menu>
  );

  const handleStatusUpdate = async (invoice, newStatus) => {
    setUpdatingPayment(true);
    setUpdatingInvoiceId(invoice.id);
    try {
      // Prepare payload for API
      const payload = {
        InvoiceNo: invoice.invoiceId,
        Partner: invoice.partner,
        Status: newStatus,
        UpdatedBy: invoice.partner // You may want to use a logged-in user instead
      };
      const URL = process.env.REACT_APP_BE_URL + "/updatePartnerInvoice";
      const response = await axios.put(URL, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      if (response.data.status === "Success") {
        setInvoices((prevInvoices) =>
          prevInvoices.map((inv) =>
            inv.invoiceId === invoice.invoiceId ? { ...inv, status: newStatus } : inv
          )
        );
        message.success(response.data.message || `Status updated to ${newStatus} successfully!`);
      } else {
        message.error(response.data.message || `Failed to update status: ${newStatus}`);
      }
    } catch (error) {
      console.error("Status update error:", error);
      message.error(`Failed to update status: ${error.response?.data?.message || error.message || "Unknown error"}`);
    } finally {
      setUpdatingPayment(false);
      setUpdatingInvoiceId(null);
    }
  };

  const filteredInvoices = useMemo(() => {
    const query = searchQuery.toLowerCase().trim();

    return invoices.filter((inv) => {
      // Check all searchable fields
      return (
        (inv.invoiceId?.toLowerCase().includes(query)) ||
        (inv.partner?.toLowerCase().includes(query)) ||
        (inv.invoiceFrom?.toLowerCase().includes(query)) ||
        (inv.currencySymbol?.toLowerCase().includes(query)) ||
        (inv.referencePONo?.toLowerCase().includes(query)) ||
        (inv.status?.toLowerCase().includes(query)) ||
        (moment(inv.invoiceDate).format('YYYY-MM-DD').includes(query)) ||
        (inv.total?.toString().includes(query))
      );
    });
  }, [searchQuery, invoices]);

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredInvoices.slice(indexOfFirstRecord, indexOfLastRecord);
  const totalPages = Math.ceil(filteredInvoices.length / recordsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="content-page">
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col">
            <h3 className="title mb-2">Partner Invoices</h3>
          </div>
          <div className="col-auto">
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={handleGenerateInvoiceClick}
              style={{
                backgroundColor: "#004f7c",
                borderColor: "#004f7c",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              Generate Invoice
            </Button>
          </div>
        </div>
        <div className="row align-items-center justify-content-center">
          <div className="col-5">
            <div className="input-group mb-0">
              <input
                type="search"
                className="form-control search-input"
                placeholder="Search invoices..."
                value={searchQuery}
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                  setCurrentPage(1); // Reset to first page when searching
                }}
                style={{ width: '100%', maxWidth: '300px' }}
              />
              <div className="input-group-append">
                <button className="btn btn-primary" type="button" title="Search" rel="tooltip">
                  <i className="ri-menu-search-line"></i>
                </button>
              </div>
            </div>
            <small className="form-text text-muted text-start mt-0">
              <i className="ri-information-2-line"></i> Search by Invoice No, Partner, Invoice
              From , Date , Status
            </small>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-md-12">
            <div className="table-responsive asset-information">
              <table className="table grid">
                <thead className="bg-light">
                  <tr>
                    <th>Invoice No</th>
                    <th>Partner</th>
                    <th>Invoice From</th>
                    <th>Invoice Date</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan={10} className="text-center py-4">
                        <span className="loader"></span>
                      </td>
                    </tr>
                  ) : currentRecords.length === 0 ? (
                    <tr>
                      <td colSpan={10} className="text-center py-4">
                        <div className="no-data-wrapper">
                          <div className="no-data-found">
                            <i className="ri-file-damage-fill"></i>
                            <div className="bounce">
                              <i className="ri-search-eye-line"></i>
                            </div>
                            <p>No Invoices Found</p>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    currentRecords.map((inv) => (
                      <tr key={inv.invoiceId}>
                        <td>{inv.invoiceId}</td>
                        <td>{inv.partner}</td>
                        <td>{inv.invoiceFrom}</td>
                        <td>{moment(inv.invoiceDate).format("YYYY-MM-DD")}</td>
                        <td>
                          <span
                            className={`badge border status-badge ${inv.status === "Paid"
                              ? "border-success text-success"
                              : inv.status === "Pending"
                                ? "border-warning text-warning"
                                : inv.status === "Reject" || inv.status === "reject"
                                  ? "border-danger text-danger"
                                  : "border-secondary text-secondary"
                              }`}
                          >
                            {inv.status}
                          </span>
                        </td>
                        <td>{renderActions(inv)}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="col-md-12">
          <div className="container-fluid">
            <div className="row border-top pt-3">
              <div className="col-auto">
                <p className="mt-1 mb-0">Records</p>
              </div>
              <div className="col-1.2 record-drop">
                <select
                  className="form-control"
                  value={recordsPerPage}
                  onChange={(e) => {
                    setRecordsPerPage(Number(e.target.value));
                    setCurrentPage(1);
                  }}
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="15">15</option>
                  <option value="20">20</option>
                  <option value="25">25</option>
                </select>
              </div>
              <div className="col">
                                <nav>
                                    <ul className="pagination justify-content-center">
                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                            <button className="page-link" onClick={() => paginate(1)} tabIndex="-1">
                                                <i className="ri-arrow-left-double-line"></i>
                                            </button>
                                        </li>
                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                            <button className="page-link" onClick={() => paginate(currentPage - 1)} tabIndex="-1">
                                                <i className="ri-arrow-left-s-line"></i>
                                            </button>
                                        </li>
                                        {Array.from({ length: totalPages }, (_, index) => (
                                            <li key={index + 1} className={`page-item ${index + 1 === currentPage ? 'active' : ''}`}>
                                                <button className="page-link" onClick={() => paginate(index + 1)}>
                                                    {index + 1}
                                                </button>
                                            </li>
                                        ))}
                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                            <button className="page-link" onClick={() => paginate(currentPage + 1)}>
                                                <i className="ri-arrow-right-s-line"></i>
                                            </button>
                                        </li>
                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                            <button className="page-link" onClick={() => paginate(totalPages)}>
                                                <i className="ri-arrow-right-double-fill"></i>
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
              <div className="col-auto">
                <p className="mt-1 mb-0">
                  Page Showing {currentPage} of {totalPages}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Generate Invoice Modal */}
        <Modal
          title={<span className={styles.modalTitle}>Generate Invoice</span>}
          visible={isGenerateModalVisible}
          onCancel={handleGenerateModalCancel}
          width={800}
          footer={null}
          destroyOnClose
          className={styles.modal}
        >
          <div className={styles.modalContent}>
            <Form form={generateForm} layout="vertical" onFinish={handleSubmit} requiredMark={false}>
              <Row gutter={16}>
                <Col span={12}>
                  <div className={styles.inputWrapper}>
                    <label className={styles.fgInput}>
                      Invoice Number <span style={{ color: "red" }}>*</span>
                    </label>
                    <Form.Item
                      name="invoiceNo"
                      rules={[{ required: true, message: "Please enter invoice number" }]}
                    >
                      <Input className={styles.forminput} placeholder="Enter invoice number" />
                    </Form.Item>
                  </div>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={12}>
                  <div className={styles.inputWrapper}>
                    <label className={styles.fgInput}>
                      To (Partner) <span style={{ color: "red" }}>*</span>
                    </label>
                    <Form.Item
                      name="partner"
                      rules={[{ required: true, message: "Please select a partner" }]}
                    >
                      <Select
                        className={styles.forminput}
                        placeholder="Select partner"
                        value={formData.partner || null}
                        onChange={(selectedOption) =>
                          updateFormData("partner", selectedOption ? selectedOption.value : '')
                        }
                        options={assignToOptions}
                        isClearable
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          control: (base) => ({ ...base, zIndex: 1 }),
                        }}
                      />
                    </Form.Item>
                  </div>
                </Col>
                <Col span={12}>
                  <div className={styles.inputWrapper}>
                    <label className={styles.fgInput}>
                      Invoice From <span style={{ color: "red" }}>*</span>
                    </label>
                    <Form.Item
                      name="invoiceFrom"
                      rules={[{ required: true, message: "Please enter invoice from" }]}
                    >
                      <Select
                        className={styles.forminput}
                        placeholder="Select invoice from"
                        value={formData.invoiceFrom || null}
                        onChange={(selectedOption) =>
                          updateFormData("invoiceFrom", selectedOption ? selectedOption.value : '')
                        }
                        options={partnerOptions}
                        isClearable
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          control: (base) => ({ ...base, zIndex: 1 }),
                        }}
                      />
                    </Form.Item>
                  </div>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={12}>
                  <div className={styles.inputWrapper}>
                    <label className={styles.fgInput}>
                      Currency <span style={{ color: "red" }}>*</span>
                    </label>
                    <Form.Item
                      name="currencySymbol"
                      rules={[{ required: true, message: "Please select a currency" }]}
                    >
                      <Select
                        className={styles.forminput}
                        placeholder="Select currency"
                        value={formData.currencySymbol || null}
                        onChange={(selectedOption) =>
                          updateFormData("currencySymbol", selectedOption ? selectedOption.value : '')
                        }
                        options={currencyOptions}
                        isClearable
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          control: (base) => ({ ...base, zIndex: 1 }),
                        }}
                      />
                    </Form.Item>
                  </div>
                </Col>
                <Col span={12}>
                  <div className={styles.inputWrapper}>
                    <label className={styles.fgInput}>Reference PO No</label>
                    <Form.Item name="refPoNumber">
                      <Input
                        className={styles.forminput}
                        value={formData.refPoNumber}
                        onChange={(e) => updateFormData("refPoNumber", e.target.value)}
                        placeholder="Enter reference PO number (optional)"
                        style={{ width: "100%" }}
                      />
                    </Form.Item>
                  </div>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={12}>
                  <div className={styles.inputWrapper}>
                    <label className={styles.fgInput}>
                      Invoice Date <span style={{ color: "red" }}>*</span>
                    </label>
                    <Form.Item
                      name="invoiceDate"
                      rules={[{ required: true, message: "Please select invoice date" }]}
                    >
                      <DatePicker
                        className={styles.forminput}
                        value={formData.invoiceDate}
                        onChange={(date) => updateFormData("invoiceDate", date)}
                        style={{ width: "100%" }}
                        format="YYYY-MM-DD"
                      />
                    </Form.Item>
                  </div>
                </Col>
                <Col span={12}>
                  <div className={styles.inputWrapper}>
                    <label className={styles.fgInput}>
                      Due Date <span style={{ color: "red" }}></span>
                    </label>
                    <Form.Item
                      name="dueDate"
                      rules={[{ required: true, message: "Please select due date" }]}
                    >
                      <DatePicker
                        className={styles.forminput}
                        value={formData.dueDate}
                        onChange={(date) => updateFormData("dueDate", date)}
                        style={{ width: "100%" }}
                        format="YYYY-MM-DD"
                      />
                    </Form.Item>
                  </div>
                </Col>
              </Row>
              <Divider orientation="left" className={styles.dividerText}>
                Invoice Items
              </Divider>
              <Table
                columns={getItemColumns()}
                dataSource={items}
                pagination={false}
                size="small"
                bordered
                style={{ marginBottom: 16 }}
                scroll={{ x: 700 }}
              />
              <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
                <Col>
                  <Button
                    type="dashed"
                    className={styles.addresource}
                    onClick={addItem}
                    icon={<PlusOutlined />}
                    style={{ marginRight: "8px" }}
                  >
                    Add Item
                  </Button>
                  <Button
                    type="default"
                    className={styles.addresource}
                    onClick={() => setShowAdditionalTaxForm(true)}
                    icon={<PlusOutlined />}
                    style={{
                      backgroundColor: "#004f7c",
                      color: "#fff",
                      borderColor: "#25b740"
                    }}
                  >
                    Add Tax Value
                  </Button>
                </Col>
                <Col>
                  <div className={styles.totalSection}>
                    <div className={styles.totalRow}>
                      <span>Subtotal:</span>
                      <span>{formData.currencySymbol || ""} {items.reduce((total, item) => total + (item.quantity || 0) * (item.rate || 0), 0).toFixed(2)}</span>
                    </div>
                    <div className={styles.totalRow}>
                      <span>{getTaxDisplayText()}:</span>
                      <span>{formData.currencySymbol || ""} {items.reduce((total, item) => total + calculateItemTax(item.quantity || 0, item.rate || 0, item.tax || additionalTaxConfig.percentage || 0), 0).toFixed(2)}</span>
                    </div>
                    <div className={styles.totalAmount}>
                      <span>Total:</span>
                      <span>{formData.currencySymbol || ""} {calculateGrandTotal().toFixed(2)}</span>
                    </div>
                  </div>
                </Col>
              </Row>
              {showAdditionalTaxForm && (
                <Card
                  title={
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <span style={{ fontSize: "16px" }}>💰</span>
                      <span>Add Tax Value</span>
                    </div>
                  }
                  style={{
                    marginBottom: 16,
                    borderColor: "#004f7c",
                    borderRadius: "8px",
                    boxShadow: "0 2px 8px rgba(0, 79, 124, 0.15)",
                    overflow: "hidden",
                  }}
                  headStyle={{
                    background: "linear-gradient(135deg, #e6f7ef 0%, #d9fbe6 100%)",
                    borderBottom: "1px solid #25b740",
                    color: "#004f7c",
                    fontWeight: "600",
                    fontSize: "14px",
                    padding: "12px 16px",
                  }}
                  bodyStyle={{
                    padding: "16px",
                    backgroundColor: "#fafafa",
                  }}
                >
                  <div style={{ marginBottom: "16px" }}>
                    <Row gutter={16}>
                      <Col span={12}>
                        <div style={{ marginBottom: "6px" }}>
                          <label
                            style={{
                              display: "block",
                              fontSize: "14px",
                              fontWeight: "500",
                              color: "#333",
                              marginBottom: "8px",
                            }}
                          >
                            Tax Name 
                          </label>
                          <Input
                            placeholder="e.g., GST, VAT, Sales Tax"
                            value={additionalTaxConfig.taxName || ""}
                            onChange={(e) =>
                              setAdditionalTaxConfig((prev) => ({
                                ...prev,
                                taxName: e.target.value,
                              }))
                            }
                            style={{
                              width: "100%",
                              height: "40px",
                              borderRadius: "8px",
                              border: "2px solid #e6e6e6",
                            }}
                          />
                        </div>
                      </Col>
                      <Col span={12}>
                        <div style={{ marginBottom: "6px" }}>
                          <label
                            style={{
                              display: "block",
                              fontSize: "14px",
                              fontWeight: "500",
                              color: "#333",
                              marginBottom: "8px",
                            }}
                          >
                            Add Tax Value (%) 
                          </label>
                          <InputNumber
                            min={0}
                            max={100}
                            precision={2}
                            placeholder="0.00"
                            value={additionalTaxConfig.percentage || null}
                            onChange={(value) =>
                              setAdditionalTaxConfig((prev) => ({
                                ...prev,
                                percentage: value,
                              }))
                            }
                            style={{
                              width: "100%",
                              height: "40px",
                              borderRadius: "8px",
                              border: "2px solid #e6e6e6",
                              fontFamily: "monospace",
                              fontVariantNumeric: "tabular-nums",
                            }}
                          />
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: "8px",
                      paddingTop: "12px",
                      borderTop: "1px solid #e6e6e6",
                      marginTop: "12px",
                    }}
                  >
                    <Button
                      onClick={() => {
                        setShowAdditionalTaxForm(false);
                        setAdditionalTaxConfig({
                          enabled: false,
                          percentage: 0,
                          taxName: "",
                        });
                        setItems((prev) =>
                          prev.map((item) => ({
                            ...item,
                            tax: 0,
                            LineItemTotal: calculateItemSubtotal(item.quantity || 0, item.rate || 0, 0),
                          }))
                        );
                      }}
                      style={{
                        height: "40px",
                        borderRadius: "8px",
                        border: "2px solid #d9d9d9",
                        fontWeight: "500",
                      }}
                    >
                      Cancel
                    </Button>
                    {additionalTaxConfig.enabled && (
                      <Button
                        danger
                        onClick={() => {
                          setAdditionalTaxConfig({
                            enabled: false,
                            percentage: 0,
                            taxName: "",
                          });
                          setShowAdditionalTaxForm(false);
                          setItems((prev) =>
                            prev.map((item) => ({
                              ...item,
                              tax: 0,
                              LineItemTotal: calculateItemSubtotal(item.quantity || 0, item.rate || 0, 0),
                            }))
                          );
                          message.success("Additional tax removed");
                        }}
                        style={{
                          height: "40px",
                          borderRadius: "8px",
                          fontWeight: "500",
                        }}
                      >
                        🗑️ Remove Tax
                      </Button>
                    )}
                    <Button
                      type="primary"
                      onClick={() => {
                        if (!additionalTaxConfig.taxName?.trim()) {
                          message.error("Please enter a tax name");
                          return;
                        }
                        if (additionalTaxConfig.percentage <= 0) {
                          message.error("Please enter a valid tax percentage");
                          return;
                        }
                        setAdditionalTaxConfig((prev) => ({
                          ...prev,
                          enabled: true,
                        }));
                        setItems((prev) =>
                          prev.map((item) => ({
                            ...item,
                            tax: additionalTaxConfig.percentage,
                            LineItemTotal: calculateItemSubtotal(item.quantity || 0, item.rate || 0, additionalTaxConfig.percentage),
                          }))
                        );
                        setShowAdditionalTaxForm(false);
                        message.success("Additional tax configured successfully");
                      }}
                      style={{
                        backgroundColor: "#004f7c",
                        borderColor: "#25b740",
                        height: "40px",
                        borderRadius: "8px",
                        fontWeight: "500",
                        boxShadow: "0 2px 8px rgba(0, 79, 124, 0.3)",
                      }}
                    >
                      ✅ Apply Tax
                    </Button>
                  </div>
                </Card>
              )}
              <div className={styles.inputWrapper}>
                <label className={styles.fgInput}>
                  Notes/Payment Terms <span style={{ color: "red" }}>*</span>
                </label>
                <Form.Item
                  name="termsConditions"
                  rules={[{ required: true, message: "Please enter notes/payment terms" }]}
                >
                  <TextArea
                    className={styles.forminputRemarks}
                    rows={3}
                    value={formData.termsConditions}
                    onChange={(e) => updateFormData("termsConditions", e.target.value)}
                    placeholder="Enter Notes/Payment Terms (mandatory)"
                  />
                </Form.Item>
              </div>
              <Divider />
              <div className={styles.actions}>
                <Button className={styles.obrsrcbtn} icon={<EyeOutlined />} onClick={handlePreview}>
                  Preview
                </Button>
                <Button className={styles.obrsrcbtn} onClick={handleGenerateModalCancel}>
                  Cancel
                </Button>
                <Button
                  className={styles.obrsrcbtn}
                  icon={<DownloadOutlined />}
                  onClick={handleDownloadPDF}
                  disabled={!previewData}
                >
                  Download PDF
                </Button>
                <Button
                  className={styles.obrsrcbtn}
                  icon={<MailOutlined />}
                  onClick={() => {
                    setIsEmailModalVisible(true);
                    emailForm.resetFields();
                  }}
                  disabled={!previewData}
                >
                  Send Email
                </Button>
              </div>
            </Form>
          </div>
        </Modal>

        {/* Preview Modal */}
        <Modal
          title={<span className={styles.modalTitle}>
            Invoice Preview - {previewData?.invoiceNumber || "N/A"}
          </span>}
          visible={previewVisible}
          onCancel={() => setPreviewVisible(false)}
          width={1000}
          footer={[
            <Button
              key="close"
              onClick={() => setPreviewVisible(false)}
              className={styles.obrsrcbtn}
            >
              Close
            </Button>,
            isGenerateModalVisible && (
              <Button
                key="create"
                className={styles.obrsrcldbtn}
                loading={loading}
                onClick={handleSubmit}
              >
                Create Invoice
              </Button>
            ),
          ].filter(Boolean)}
          destroyOnClose
          className={styles.invoiceModal}
        >
          <div style={{ height: '80vh' }}>
            {previewData ? (
              <PDFViewer width="100%" height="100%">
                <PdfInvoice data={previewData} partnerBankDetails={partnerBankDetails} organisationPartnerDetails={organisationPartnerDetails} />
              </PDFViewer>
            ) : (
              <div style={{ textAlign: "center", padding: "40px" }}>
                <p>No preview data available.</p>
              </div>
            )}
          </div>
        </Modal>

        {/* Email Modal */}
        <Modal
          title="Send Invoice via Email"
          visible={isEmailModalVisible}
          onCancel={handleEmailModalCancel}
          footer={null}
        >
          <Form form={emailForm} layout="vertical" onFinish={selectedInvoice ? handleEmailSend : handleSendEmail}>
            <Form.Item
              name="email"
              label="Recipient Email"
              rules={[
                { required: true, message: "Please enter recipient email" },
                { type: "email", message: "Please enter a valid email" },
              ]}
            >
              <Input placeholder="Enter email address" />
            </Form.Item>
            <Form.Item>
              <Space>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={sendingEmail}
                  style={{ backgroundColor: "#004f7c", borderColor: "#004f7c" }}
                >
                  Send
                </Button>
                <Button onClick={handleEmailModalCancel}>Cancel</Button>
              </Space>
            </Form.Item>
          </Form>
        </Modal>

        {/* View Modal */}
        <Modal
          title={`Invoice Details - ${selectedInvoice?.invoiceId}`}
          visible={isViewModalVisible}
          onCancel={handleViewModalCancel}
          width={800}
          footer={[
            <Button key="close" onClick={handleViewModalCancel}>
              Close
            </Button>,
            <Button
              key="download"
              type="primary"
              icon={<DownloadOutlined />}
              onClick={() => handleDownloadInvoiceFile(selectedInvoice)}
              style={{ backgroundColor: "#004f7c", borderColor: "#004f7c" }}
            >
              Download
            </Button>,
          ]}
        >
          {selectedInvoice && (
            <div style={{ height: "600px", overflow: "auto" }}>
              {selectedInvoice.invoiceFile ? (
                <iframe
                  src={selectedInvoice.invoiceFile}
                  width="100%"
                  height="100%"
                  title={`Invoice ${selectedInvoice.invoiceId}`}
                  style={{ border: "none" }}
                />
              ) : (
                <p>No invoice file available for this invoice.</p>
              )}
            </div>
          )}
        </Modal>
      </div>
    </div>
  );
}

export default PartnerInvoice;